import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';

// グローバルエラーハンドリング
const handleError = (error: unknown) => {
  console.error('Query error:', error);

  // エラー型を判定してユーザーフレンドリーなメッセージに変換
  if (error && typeof error === 'object' && 'statusCode' in error) {
    const apiError = error as { statusCode: number; message: string };

    switch (apiError.statusCode) {
      case 401:
        // 認証エラー - ログイン画面にリダイレクト
        console.warn('認証エラー: 再ログインが必要です');
        break;
      case 403:
        console.warn('アクセス権限がありません');
        break;
      case 404:
        console.warn('データが見つかりません');
        break;
      case 500:
        console.error('サーバーエラーが発生しました');
        break;
      default:
        console.error(`エラーが発生しました: ${apiError.message}`);
    }
  }
};

// QueryClientの設定
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // データの再フェッチ設定
      staleTime: 5 * 60 * 1000, // 5分間はデータを新鮮とみなす
      gcTime: 10 * 60 * 1000, // 10分間キャッシュを保持 (旧cacheTime)

      // リトライ設定
      retry: (failureCount, error) => {
        // 404や401などはリトライしない
        if (error && typeof error === 'object' && 'statusCode' in error) {
          const statusCode = (error as { statusCode: number }).statusCode;
          if (statusCode === 404 || statusCode === 401 || statusCode === 403) {
            return false;
          }
        }
        // 最大3回までリトライ
        return failureCount < 3;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),

      // ネットワークモード設定
      networkMode: 'online',

      // バックグラウンドでの自動再フェッチ
      refetchOnWindowFocus: false, // ウィンドウフォーカス時の再フェッチを無効化
      refetchOnReconnect: true,    // ネットワーク再接続時は再フェッチ
      refetchOnMount: true,         // マウント時は再フェッチ
    },
    mutations: {
      // リトライ設定（mutation は通常リトライしない）
      retry: false,
      networkMode: 'online',
    },
  },

  // グローバルエラーハンドリング
  queryCache: new QueryCache({
    onError: handleError,
  }),
  mutationCache: new MutationCache({
    onError: handleError,
  }),
});

export default queryClient;
